import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

/**
 * Applies the current tenant's branding (primary colour + logo) to the DOM:
 *  - Sets the --brand CSS variable.
 *  - Sets a `data-tenant-logo` attribute on <body> so components can read it.
 * Super admins keep the default Lanvaus branding (their tenant is "lanvaus").
 */
export default function BrandingProvider({ children }) {
  const { user } = useAuth();
  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await api.get('/branding/me');
        if (data?.primary_color) document.documentElement.style.setProperty('--brand', data.primary_color);
        if (data?.logo_url) document.body.setAttribute('data-tenant-logo', data.logo_url);
        if (data?.company_name) document.body.setAttribute('data-tenant-name', data.company_name);
      } catch (e) { /* fallback to default */ }
    })();
  }, [user?.id]);
  return children;
}
